var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sizeClass},[(_vm.segment.style === 'line')?_c('hr',{staticClass:"border-t border-stack-text"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }